import { format } from 'date-fns';
import ToggleShowVal from '../components/ToggleShowVal';

export const formatDateCell = ({ value, ifEmpty }) => {
  if (!value) {
    return ifEmpty ? ifEmpty : value;
  }
  let parsedValue = Number(value);
  try {
    return new Date(isNaN(parsedValue) ? value : parsedValue).toString();
  } catch (err) {
    return '❗Error formatting date';
  }
};

export const formatDateCellISO = ({ value, ifEmpty }) => {
  if (!value) {
    return ifEmpty ? ifEmpty : value;
  }
  let parsedValue = Number(value);
  try {
    return new Date(isNaN(parsedValue) ? value : parsedValue).toISOString();
  } catch (err) {
    return '❗Error formatting date';
  }
};

export const formatDateCellShort = ({ value, ifEmpty }) => {
  if (!value) {
    return ifEmpty ? ifEmpty : value;
  }
  let parsedValue = Number(value);
  try {
    return new Date(isNaN(parsedValue) ? value : parsedValue).toDateString();
  } catch (err) {
    return '❗Error formatting date';
  }
};

export const formatDateCellCustom = ({
  value,
  ifEmpty,
  pattern,
}: {
  value: string;
  ifEmpty?: string;
  pattern?: string;
}) => {
  if (!value) {
    return ifEmpty ? ifEmpty : value;
  }
  let parsedValue = Number(value);
  try {
    if (pattern) {
      return format(
        new Date(isNaN(parsedValue) ? value : parsedValue),
        pattern
      );
    }
    return new Date(isNaN(parsedValue) ? value : parsedValue).toLocaleString();
  } catch (err) {
    return '❗Error formatting date';
  }
};

export const formatNumberWithCommas = ({ value, ifEmpty }) => {
  if (!value) {
    return ifEmpty ? ifEmpty : value;
  }
  try {
    return value.toLocaleString();
  } catch (err) {
    return value;
  }
};

export const wrapInToggleShowVal = ({ value }) => {
  if (!value) {
    return value;
  }
  return <ToggleShowVal>{value}</ToggleShowVal>;
};

export const formatFileStatus = ({ value }) => {
  if (!value) return value;

  let formatted = value.replace('-', ' ');

  switch (value) {
    case 'processing':
      formatted = 'Processing (Step 1 of 4)';
      return <p>{formatted}</p>;
      break;
    case 'matching':
      formatted = 'Matching (Step 2 of 4)';
      return <p>{formatted}</p>;
      break;
    case 'matched':
      formatted = 'Indexing (Step 3 of 4)';
      return <p>{formatted}</p>;
      break;
    default:
      break;
  }

  return <p className="capitalize">{formatted}</p>;
};
